// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"input_checkbox__Uc5Dz"};